import qs from 'qs'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'

import OfferCardCarouselSection, { MIN_OFFER_CAROUSEL_OFFERS_COUNT } from 'components/Common/OfferCardCarousel/OfferCardCarouselSection'
import { CRUISE_BANK_OFFERS_FILTERS } from 'constants/cruise'
import { useAppSelector } from 'hooks/reduxHooks'
import { isDateBetweenOrEqual } from 'lib/datetime/dateUtils'
import { isMobileAppSel } from 'selectors/configSelectors'

const ROYAL_CARIBBEAN_FILTERS: App.OfferListFilters = {
  ...CRUISE_BANK_OFFERS_FILTERS,
  cruiseLines: ['RCC'],
}

const WEB_ROYAL_CARIBBEAN_CAMPAIGN_SCHEDULE = {
  startDate: '2026-06-08T00:00:00+10:00',
  endDate: '2026-06-14T23:59:59+10:00',
}

const APP_ROYAL_CARIBBEAN_CAMPAIGN_SCHEDULE = {
  startDate: '2026-06-08T00:00:00+10:00',
  endDate: '2026-06-10T23:59:59+10:00',
}

function CruiseRoyalCaribbeanCampaignCarousel() {
  const isMobileApp = useAppSelector(isMobileAppSel)
  const schedule = isMobileApp ? APP_ROYAL_CARIBBEAN_CAMPAIGN_SCHEDULE : WEB_ROYAL_CARIBBEAN_CAMPAIGN_SCHEDULE
  const isWithinSchedule = isDateBetweenOrEqual(schedule.startDate, schedule.endDate)

  if (!isWithinSchedule) {
    return null
  }

  return (
    <OfferCardCarouselSection
      preferListingOffers
      filters={ROYAL_CARIBBEAN_FILTERS}
      title={<FormattedMessage
        id="PTXBXqhYZ98l5trumMgi"
        defaultMessage="Royal Caribbean Hot Deals"
        description="Section heading for the scheduled Royal Caribbean cruise offers carousel on the main home page"
      />}
      allLink={`/search/cruises?${qs.stringify({ cruiseLines: ['RCC'] }, { arrayFormat: 'repeat' })}`}
      tileStyle="card-default"
      tileSize="medium"
      hideWhenEmpty
      minimumOffersCount={MIN_OFFER_CAROUSEL_OFFERS_COUNT}
      data-testid="royal-caribbean-campaign-cruise-carousel"
    />
  )
}

export default React.memo(CruiseRoyalCaribbeanCampaignCarousel)
